<template>
    <div>
        <b-modal id="modal-list-rekening-bank" size="lg" title="List Rekening Bank">
            <div class="mb-2 d-flex justify-content-between align-items-center flex-wrap gap-2">
                <div class="d-flex items-center gap-2">
                    <span>{{ userData.namaAnggota }} - </span>
                    <span class="status-box status-box-primary">{{ userData.noAnggota }}</span>
                </div>
                <b-button v-if="!isReadOnly && showAdd" size="sm" variant="pgiBtn" @click="onShowModalAddRekening">
                    <i class="fa fa-plus mr-1"></i>
                    Tambah Rekening Baru
                </b-button>
            </div>
            <b-table :busy="stateListRekening.isLoading" bordered hover show-empty :fields="isMobile ? fieldRekeningMobileComputed : fieldRekeningDesktopComputed" :items="dataListRekening" responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data rekening.
                </template>
                <template v-if="isMobile" v-slot:cell(informasiRekening)="row">
                        <p class="mb-1"><span class="text-muted">Bank:</span> {{ row.item.bankName }}</p>
                        <p class="mb-1"><span class="text-muted">Nomor Rekening:</span> {{ row.item.noRekening }}</p>
                        <p class="mb-1"><span class="text-muted">Nama:</span> {{ row.item.namePemilikRekening }}</p>
                        <p class="mb-1"><span class="text-muted">Tanggal Pendaftaran:</span> {{ $helper.changeDateFormat(row.item.createdAt) }}</p>
                        <div class="d-flex gap-2 flex-wrap">
                            <span class="text-muted">Status: </span>
                            <div>
                                <span v-if="row.item.isActive == STATUS_REKENING.ACTIVE" class="status-box status-box-success text-center" style="width: 133px;">Aktif</span>
                                <span v-else class="status-box status-box-danger text-center" style="width: 133px;">Non Aktif</span>
                            </div>
                            <div>
                                <span v-if="row.item.isVerified" class="status-box status-box-primary text-center" style="width: 133px;">Sudah Verifikasi</span>
                                <span v-else class="status-box status-box-secondary text-center" style="width: 133px;">Belum Terverifikasi</span>
                            </div>
                        </div>
                </template>
                <template v-slot:cell(createdAt)="row">
                    <span>{{ $helper.changeDateFormat(row.item.createdAt) }}</span>
                </template>
                <template v-slot:cell(status)="row">
                    <div>
                        <span v-if="row.item.isActive == STATUS_REKENING.ACTIVE" class="status-box status-box-success text-center" style="width: 133px;">Aktif</span>
                        <span v-else class="status-box status-box-danger text-center" style="width: 133px;">Non Aktif</span>
                    </div>
                    <div class="mt-2">
                        <span v-if="row.item.isVerified" class="status-box status-box-primary text-center" style="width: 133px;">Sudah Verifikasi</span>
                        <span v-else class="status-box status-box-secondary text-center" style="width: 133px;">Belum Terverifikasi</span>
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="d-flex flex-wrap" style="gap: 8px;">
                        <b-button size="sm" v-if="showChoose && row.item.isActive == STATUS_REKENING.ACTIVE" variant="pgiBtn" @click="onChooseRekening(row.item)">
                            Pilih
                        </b-button>
                        <b-button v-if="showNonAktif && row.item.isActive == STATUS_REKENING.ACTIVE" size="sm" variant="danger" @click="onShowModalInactive(row.item)">
                            Nonaktifkan
                        </b-button>
                        <b-button v-if="showAktif && row.item.isActive == STATUS_REKENING.NONACTIVE" size="sm" variant="success" @click="onShowModalActive(row.item)">
                            Aktifkan
                        </b-button>
                    </div>
                </template>
            </b-table>

            <b-alert :show="showAlert" variant="info" class="mb-0">
                <h5>Informasi</h5>
                Rekening dengan status nonaktif tidak dapat digunakan.
                Silakan menghubungi HO untuk proses aktivasi.
            </b-alert>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeBtn" @click="cancel()">
                    Cancel
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-inactive" title="Konfirmasi Non-Aktif Rekening" no-close-on-backdrop>
            <div class="mb-3">
                <p class="mb-0">
                    Apakah Anda yakin ingin menonaktifkan rekening ini? 
                    Tindakan ini akan membuat rekening tidak dapat digunakan.
                </p>
            </div>
            <b-form id="inactiveForm" @submit.prevent="onInactive">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Keterangan / Alasan Non-Aktif" class="mb-0">
                        <b-form-textarea
                            v-model="reasonInactive" name="keteranganInactive"
                            rows="3"
                            max-rows="6"
                            maxlength="150"
                            required
                        ></b-form-textarea>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ cancel }" >
                <b-button variant="secondary" name="cancelInactiveBtn" :disabled="isLoadingInactive" @click="cancel()">
                    Cancel
                </b-button>
                <b-button type="submit" name="InactiveSubmitBtn" variant="danger" :disabled="isLoadingInactive" form="inactiveForm">
                    {{ isLoadingInactive ? "Sedang mengirim..." : "Ya" }}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-active" title="Konfirmasi Aktifkan Rekening" no-close-on-backdrop>
            <div class="mb-3">
                <p class="mb-0">
                    Apakah Anda yakin ingin mengaktifkan rekening ini? 
                    Tindakan ini akan membuat rekening tidak dapat digunakan.
                </p>
            </div>
            <b-form id="activeForm" @submit.prevent="onActive">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Keterangan / Alasan Mengaktifkan" class="mb-0">
                        <b-form-textarea
                            v-model="reasonActive" name="keteranganActive"
                            rows="3"
                            max-rows="6"
                            maxlength="150"
                            required
                        ></b-form-textarea>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ cancel }" >
                <b-button variant="secondary" name="cancelActiveBtn" :disabled="isLoadingActive" @click="cancel()">
                    Cancel
                </b-button>
                <b-button type="submit" name="ActiveSubmitBtn" variant="success" :disabled="isLoadingActive" form="activeForm">
                    {{ isLoadingActive ? "Sedang mengirim..." : "Ya" }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import CONSTANTS from '@/constants'

export default {
    name: 'modal-list-rekening-bank',
    props: {
        dataListRekening: {
            type: Array,
            default: () => []
        },
        stateListRekening: {
            type: Object,
            default: () => ({}),
        },
        userData: {
            type: Object,
            required: true,
        },
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        showAdd: {
            type: Boolean,
            default: false,
        },
        showChoose: {
            type: Boolean,
            default: false,
        },
        showNonAktif: {
            type: Boolean,
            default: false,
        },
        showAktif: {
            type: Boolean,
            default: false,
        },
        showAlert: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isMobile: false,
            fieldListRekeningDesktop: [
                { key: "bankName", label: "Bank", thClass: 'text-center', tdClass: 'text-center'},
                { key: "noRekening", label: "Nomor Rekening", thClass: 'text-center', tdClass: 'text-center' },
                { key: "namePemilikRekening", label: "Nama", thClass: 'text-center', tdClass: 'text-center' },
                { key: "createdAt", label: "Tanggal Pendaftaran", thClass: 'text-center', tdClass: 'text-center' },
                { key: "status", label: "Status", thClass: 'min-width-175 text-center', tdClass: 'min-width-175 text-center' },
                { key: "action", label: "Aksi", thClass: 'text-center', tdClass: 'text-center' },
            ],
            fieldListRekeningMobile: [
                { key: "informasiRekening", label: "Informasi Rekening" },
                { key: "action", label: "Aksi", thClass: 'text-center', tdClass: 'text-center' },
            ],
            isLoadingInactive: false,
            isLoadingActive: false,
            reasonInactive: '',
            reasonActive: '',
        }
    },
    computed: {
        fieldRekeningDesktopComputed() {
            if (this.isReadOnly) {
                return this.fieldListRekeningDesktop.filter(
                    field => field.key !== 'action'
                )
            }
            return this.fieldListRekeningDesktop
        },

        fieldRekeningMobileComputed() {
            if (this.isReadOnly) {
                return this.fieldListRekeningMobile.filter(
                    field => field.key !== 'action'
                )
            }
            return this.fieldListRekeningMobile
        },

        STATUS_REKENING() {
            return CONSTANTS.REKENING.STATUS
        },
    },
    methods: {
        onShowModalAddRekening() {
            this.$emit('onShowModalAddRekening')
        },
        onChooseRekening(data) {
            this.$emit('onChooseRekening', data)
        },
        onShowModalInactive(row) {
            this.selectedRow = row;
            this.$bvModal.show("modal-inactive")
        },
        onShowModalActive(row) {
            this.selectedRow = row;
            this.$bvModal.show("modal-active")
        },
        onInactive() {
            if (this.$helper.isNullOrEmpty(this.reasonInactive)) {
                this.$helper.toastErr(this, "Harap mengisi keterangan / alasan non-aktif.")
                return;
            }

            const id = this.selectedRow.id;
            const payload = {
                reason: this.reasonInactive,
            }
            this.isLoadingInactive = true;
            this.$axios.put(`nasabah/${id}/deactivate-bank-account`, {}, { params: payload })
                .then((response) => {
                    this.$helper.toastSucc(this, response.data.name)
                    this.$bvModal.hide("modal-inactive")
                    this.reasonInactive = ''
                    this.$emit('onSubmitInactiveRekening', id)
                })
                .catch((error) => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isLoadingInactive = false;
                })
        },
        onActive() {
            if (this.$helper.isNullOrEmpty(this.reasonActive)) {
                this.$helper.toastErr(this, "Harap mengisi keterangan / alasan mengaktifkan.")
                return;
            }

            const id = this.selectedRow.id;
            const payload = {
                reason: this.reasonActive,
            }
            this.isLoadingActive = true;
            this.$axios.put(`nasabah/${id}/reactivate-bank-account`, {}, { params: payload })
                .then((response) => {
                    this.$helper.toastSucc(this, response.data.name)
                    this.$bvModal.hide("modal-active")
                    this.reasonActive = ''
                    this.$emit('onSubmitActiveRekening', id)
                })
                .catch((error) => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isLoadingActive = false;
                })
        },
        handleResize() {
            this.isMobile = window.innerWidth <= 991;
        },
    },
    mounted() {
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    }
}
</script>